import { csvToObj } from 'csv-to-js-parser';
import ImportGeneric from './ImportGeneric';

export { ImportCSV as default };

/**
* CSV Parse
*
* Handler all data from file import contacts
*
* @author      brunorbarroso <bruno-b-rodrigues@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ImportCSV extends ImportGeneric {
  /**
   * Contacts Config Parse from CSV type
   *
   * @public
   *
   * @type {Object}
   * @property {string[]} fields.keys - The keys to extract from the item.
   * @property {boolean} fields.priority - Whether to prioritize keys in the order they are provided.
   *
   * @since 7.0.0
   */
  fields = {
    lastname : {
      keys: [
        // Gmail
        'Name',
        // Horde
        'name',
        // Outlook
        ['First Name', 'Middle Name', 'Last Name'],
        // Thunderbird
        'Display Name',
      ]
    },
    email : {
      keys : [
        // Gmail
        'E-mail 1 - Value',
        'E-mail 2 - Value',
        'E-mail 3 - Value',
        // Horde
        'E-mail Address',
        // Ooutlook
        'E-mail Address',
        'E-mail 2 Address',
        'E-mail 3 Address',
        // Thunderbird
        'Primary Email',
        'Secondary Email',
        'email',
        'Email',
      ],
      priority: true
    },
    cellPhone : {
      keys: [
        // Gmail
        'Phone 1 - Value',
        'Phone 2 - Value',
        'Phone 3 - Value',
        // Horde
        'Mobile Phone',
        // Outlook
        'Mobile Phone',
        'Home Phone',
        'Home Phone 2',
        'Business Phone',
        'Business Phone 2',
        // Thunderbird,
        'Mobile Phone',
        'Home Phone',
        'Work Phone',
      ],
      priority: true
    },
    homeStreet : {
      keys: [
        // Gmail
        'Location',
        'Address 1 - Street',
        'Address 1 - Postal Code',
        'Address 1 - City',
        'Address 1 - Country',
        'Address 1 - Extend Address',
        // Horde
        'Home Street',
        // Outlook
        'Home Street',
        // Thunderbird,
        'Home Address',
        'Home Address 2'
      ]
    },
    birthday : {
      keys: [
        // Gmail
        'Birthday',
        // Horde
        'Birthday',
        // Outlook
        'Birthday',
        // Thunderbird
        ['Birth Year', 'Birth Month', 'Birth Day'],
      ]
    },
    company : {
      keys: [
        // Gmail
        'Organization 1 - Name',
        'Organization 2 - Name',
        'Organization 3 - Name',
        // Horde
        'Company',
        // Outlook
        'Company',
        // Thunderbird
        'Organization',
      ]
    },
    notes : {
      keys: [
        // Gmail
        'Notes',
        // Horde
        'Notes',
        // Outlook
        'Notes',
      ]
    }
  }

  /**
   * Constructor 
   * 
   * @param {String} content 
   */
  constructor(content) {
    super(content);
    this.setContent(content);
  }

  /**
   * Method to save contacts correctly 
   * 
   * @param {String} content
   * @return {void} 
   */
  setContent(content) {
    this.content = csvToObj(content);
  }

  /**
   * 
   * @param {Object} item contact object
   * @param {Array} keys list of keys to search in object
   * @returns {String} content from object
   */
  getValueByKey(item, key){
    return item[key] ? ` ${item[key]}` : '';
  }
}